import i18nLib, { Module, Newable, NewableModule } from 'i18next';
import { Translator } from '~domain/i18n';
import { LanguageId, TranslationMap } from '~domain/model/core/supported-languages';

export function initTranslator(
  translations: Partial<TranslationMap<object>>,
  options?: {
    plugins?: (Module | NewableModule<Module> | Newable<Module>)[];
    fixedTLng?: LanguageId;
    escapeValue?: boolean;
    mockedT?: (key: string) => string;
    mockedTExists?: (key: string) => boolean;
  },
) {
  // Configure of i18n
  // id to configuration of languages has to be the same as in SupportedLanguages object
  if (options?.plugins?.length) {
    options.plugins.forEach((plugin) => i18nLib.use(plugin));
  }
  void i18nLib.init(createI18nInitConfig(translations, { escapeValue: options?.escapeValue }));
  const i18n = i18nLib;

  const t = options?.mockedT || (options?.fixedTLng ? i18nLib.getFixedT(options?.fixedTLng) : i18nLib.t).bind(i18n);
  const tExists = options?.mockedTExists || i18nLib.exists.bind(i18n);

  return new Translator(i18n, t, tExists);
}

export function createI18nInitConfig(translations: { [locale: string]: any }, options: { escapeValue: boolean }) {
  return {
    fallbackLng: 'en',

    ns: ['translations'],
    defaultNS: 'translations',

    resources: buildResourcesConfig(translations),

    interpolation: {
      escapeValue: options.escapeValue ?? false,
    },
  };
}

function buildResourcesConfig(translations: { [locale: string]: any }) {
  const resources = {};
  Object.keys(translations).forEach((locale) => {
    resources[locale] = {
      translations: translations[locale],
    };
  });

  return resources;
}
